/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImageManagementAddImageUploadRequest } from '../models/ImageManagementAddImageUploadRequest';
import type { ImageManagementAddImageUploadResponseApiRespoonse } from '../models/ImageManagementAddImageUploadResponseApiRespoonse';
import type { ImageManagementListLiveImageRequest } from '../models/ImageManagementListLiveImageRequest';
import type { ImageManagementListLiveImageResponseApiRespoonse } from '../models/ImageManagementListLiveImageResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ImageManagerService {

    /**
     * 投稿一覧
     * @param requestBody
     * @returns ImageManagementAddImageUploadResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminImageUpload(
        requestBody: ImageManagementAddImageUploadRequest,
    ): CancelablePromise<ImageManagementAddImageUploadResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/image/upload',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Get list live images
     * @param requestBody
     * @returns ImageManagementListLiveImageResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminImageLive(
        requestBody: ImageManagementListLiveImageRequest,
    ): CancelablePromise<ImageManagementListLiveImageResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/image/live',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
